"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function Communautaire() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const values = [{
    title: "Bienveillance",
    text: "Nous accueillons chaque étape de votre maternité avec une écoute attentive et sans jugement. Être pleinement présente est le cadeau le plus précieux que nous puissions offrir à votre famille."
  }, {
    title: "Respect",
    text: "Chaque maman et chaque bébé mérite d'être honoré dans sa singularité. Nous respectons vos choix, vos traditions et le rythme sacré de votre nouvelle vie à la maison."
  }, {
    title: "Accompagnement",
    text: "Personne ne devrait traverser le post-partum seule. Nous marchons à vos côtés, offrant un soutien émotionnel, pratique et nutritionnel avec un cœur ouvert et bienveillant."
  }];
  return;
}
function ValueStatement({
  title,
  text,
  showDivider,
  delay,
  ...rest
}: {
  title: string;
  text: string;
  showDivider: boolean;
  delay: number;
} & React.HTMLAttributes<HTMLDivElement>) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  return <div ref={ref} className={`text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
    transitionDelay: `${delay}ms`
  }} {...rest}>
      <div className="mx-auto mb-6 h-10 w-px bg-gradient-to-b from-transparent via-beige to-transparent" />
      <h3 className="font-default text-2xl font-medium tracking-normal text-foreground sm:text-3xl">
        {title}
      </h3>
      <p className="font-default mx-auto mt-4 max-w-md text-base leading-relaxed text-foreground/70">
        {text}
      </p>
      {showDivider && <Separator className="mx-auto mt-12 w-16 bg-beige" />}
    </div>;
}